const MegaMenu = () => {
    const menuButton = document.querySelector('.burger-menu');
    const menuContainer = document.querySelector('.menu-mobile-menu-container');
    if (!menuButton && !menuContainer) return;

    // Event listener to handle the menu button
    menuButton.addEventListener('click', () => {
        menuButton.classList.toggle('active');
        document.body.classList.toggle('menu-open');

        // when active class doesn't exist, add aria-expanded="false" to the button
        if (!menuButton.classList.contains('active')) {
            menuButton.setAttribute('aria-expanded', 'false');
        } else {
            menuButton.setAttribute('aria-expanded', 'true');
        }
    });

    // Event listener to handle the menu container
    menuContainer.addEventListener('click', (e) => {
        const parentList = e.target.closest('li');

        if (parentList && parentList.classList.contains('menu-item-has-children')) {
            e.preventDefault();
            parentList.querySelector('.sub-menu').classList.toggle('open');
            parentList.classList.toggle('sub-menu-open');

            // Hide all other links
            menuContainer.querySelectorAll('ul#menu-mobile > li > a').forEach((link) => {
                link.classList.add('d-none');
            });
        }

    });

    // Add "Back" link to first level sub-menus
    const subMenus = document.querySelectorAll('ul#menu-mobile > li > ul.sub-menu');
    subMenus.forEach((subMenu) => {
        const backLink = document.createElement('li');
        backLink.classList.add('menu-item', 'back');
        backLink.innerHTML = '<a href="#">Back</a>';
        subMenu.prepend(backLink);

        // Event listener to handle the back link
        backLink.addEventListener('click', (e) => {
            e.preventDefault();
            subMenu.classList.remove('open');
    
            // Display all links when the back link is clicked
            menuContainer.querySelectorAll('ul#menu-mobile > li > a').forEach((link) => {
                link.classList.remove('d-none');
            });
        });

    });


}

export default MegaMenu;